// Shared guided-intake questions for demo/sales requests. Used by the
// /contact-sales page (GuidedIntakeForm) and the global DemoRequestDialog
// modal — keep them in sync by editing here.

export const demoIntakeSteps = [
  {
    id: "priority",
    question: "What would you most like to improve?",
    help: "Choose the outcome that matters most right now.",
    options: [
      { label: "Replace disconnected tools", value: "replace-tools", description: "Bring CRM, projects, communication, billing, and reporting together." },
      { label: "Organize clients and delivery", value: "clients-delivery", description: "Create a clearer path from request through project completion." },
      { label: "Improve communication", value: "communication", description: "Connect inbox, SMS, calling, voicemail, and client history." },
      { label: "Modernize billing and finance", value: "billing-finance", description: "Connect proposals, invoices, payments, expenses, and reporting." },
      { label: "Use AI and automation", value: "ai-automation", description: "Reduce repetitive follow-up, writing, routing, and admin work." },
    ],
  },
  {
    id: "teamSize",
    question: "How many people need to work in the system?",
    help: "An estimate is enough. This helps us recommend the right plan.",
    options: [
      { label: "Just me", value: "1" },
      { label: "2–5 people", value: "2-5" },
      { label: "6–15 people", value: "6-15" },
      { label: "16–50 people", value: "16-50" },
      { label: "More than 50", value: "51-plus" },
    ],
  },
  {
    id: "timing",
    question: "When are you hoping to make a change?",
    options: [
      { label: "As soon as possible", value: "asap" },
      { label: "Within the next month", value: "one-month" },
      { label: "This quarter", value: "this-quarter" },
      { label: "I am still exploring", value: "exploring" },
    ],
  },
  {
    id: "salesHelp",
    question: "What would be most useful from us?",
    options: [
      { label: "A product walkthrough", value: "product-walkthrough" },
      { label: "A plan and pricing recommendation", value: "plan-pricing" },
      { label: "Help replacing our current stack", value: "migration-plan" },
      { label: "A technical or security conversation", value: "technical-security" },
    ],
  },
];
